
/* ══════════════════════════════════════════════
   RoseMuse — Shopify Theme JS
   ══════════════════════════════════════════════ */

/* ── POPUP ── */
function closePopup(){sessionStorage.setItem('rm_pop','1');var p=document.getElementById('popup');if(p)p.style.display='none';}
function submitPopup(){var e=document.getElementById('popupEmail');if(!e)return;var v=e.value.trim();if(!v||!v.includes('@'))return;sessionStorage.setItem('rm_pop','1');var p=document.getElementById('popup');if(p)p.style.display='none';}

/* ── MENU DRAWER ── */
function openMenu(){var d=document.getElementById('menuDrawer'),o=document.getElementById('menuOverlay');if(d)d.classList.add('open');if(o)o.classList.add('open');document.body.style.overflow='hidden';}
function closeMenu(){var d=document.getElementById('menuDrawer'),o=document.getElementById('menuOverlay');if(d)d.classList.remove('open');if(o)o.classList.remove('open');document.body.style.overflow='';}

/* ── CART STATE ── */
var cartItems=[];
try{var _saved=sessionStorage.getItem('rm_cart');if(_saved)cartItems=JSON.parse(_saved)||[];}catch(e){cartItems=[];}
var cartN=cartItems.reduce(function(s,i){return s+i.qty;},0);
function saveCart(){try{sessionStorage.setItem('rm_cart',JSON.stringify(cartItems));}catch(e){}}
/* ── CHECKOUT ──
   En production sur Shopify : on synchronise le panier via /cart/add.js
   puis on redirige vers /checkout (page de paiement native Shopify, qui
   expose automatiquement TOUS les moyens de paiement activ&eacute;s dans
   l'admin : Carte bancaire (Shopify Payments / Stripe), Apple Pay,
   Google Pay, Shop Pay, PayPal, Klarna, Alma, etc.).
   En aper&ccedil;u statique : on retombe sur commander.html. */
function isShopifyEnv(){
  try{
    var h=window.location.hostname||'';
    if(h.indexOf('myshopify.com')>-1)return true;
    if(h.indexOf('rosemuse.')>-1)return true;
    if(window.Shopify&&window.Shopify.shop)return true;
  }catch(e){}
  return false;
}
function goCheckout(){
  saveCart();
  if(!isShopifyEnv()){window.location.href='commander.html';return;}
  /* Production : POST items vers Shopify, puis /checkout */
  var btn=document.getElementById('cartTotalBtn');
  if(btn){btn.disabled=true;btn.textContent='Redirection...';}
  var formItems=cartItems.map(function(i){
    return {id:i.variantId||i.id,quantity:i.qty};
  });
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:formItems})
  }).then(function(r){return r.json();}).then(function(){
    window.location.href='/checkout';
  }).catch(function(){
    window.location.href='/cart';
  });
}

function openCart(){
  renderCart();
  var d=document.getElementById('cartDrawer'),o=document.getElementById('cartOverlay');
  if(d)d.classList.add('open');if(o)o.classList.add('open');
  document.body.style.overflow='hidden';
}
function closeCart(){
  var d=document.getElementById('cartDrawer'),o=document.getElementById('cartOverlay');
  if(d)d.classList.remove('open');if(o)o.classList.remove('open');
  document.body.style.overflow='';
}

function addToCart(id,name,price,emoji){
  id=id||'coffret';name=name||'Coffret Shrink-Less';price=price!=null?price:129.00;emoji=emoji||'\u{1F33A}';
  var existing=cartItems.find(function(i){return i.id===id;});
  if(existing){existing.qty++;}
  else{cartItems.push({id:id,name:name,price:price,qty:1,emoji:emoji});}
  cartN=cartItems.reduce(function(s,i){return s+i.qty;},0);
  saveCart();
  var badge=document.getElementById('cartCountBadge');
  if(badge){badge.textContent=cartN;badge.style.display='flex';badge.style.transform='scale(1.4)';setTimeout(function(){badge.style.transform='';},300);}
  openCart();
}

function changeQty(id,delta){
  var item=cartItems.find(function(i){return i.id===id;});
  if(!item)return;
  item.qty+=delta;
  if(item.qty<=0)cartItems=cartItems.filter(function(i){return i.id!==id;});
  cartN=cartItems.reduce(function(s,i){return s+i.qty;},0);
  saveCart();
  var badge=document.getElementById('cartCountBadge');
  if(badge){if(cartN>0){badge.textContent=cartN;badge.style.display='flex';}else{badge.style.display='none';}}
  renderCart();
}

function renderCart(){
  var body=document.getElementById('cartBody');
  var footer=document.getElementById('cartFooter');
  if(!body||!footer)return;
  if(!cartItems.length){
    body.innerHTML='<div class="cart-empty"><svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>Votre panier est vide</div>';
    footer.style.display='none';
    return;
  }
  var html='';var total=0;var duoQty=0;var singleQty=0;
  cartItems.forEach(function(item){
    var listUnit=item.id==='coffret-duo'?260:item.price;
    var sub=(listUnit*item.qty).toFixed(2).replace('.',',');
    total+=listUnit*item.qty;
    if(item.id==='coffret-duo')duoQty+=item.qty;
    if(item.id==='coffret')singleQty+=item.qty;
    var thumb=item.emoji&&(item.emoji.indexOf('/')>-1||item.emoji.indexOf('.')>-1)?'<img src="'+item.emoji+(item.emoji.indexOf('?')>-1?'&':'?')+'v=2" alt="'+item.name+'" style="width:100%;height:100%;object-fit:cover;display:block;">':item.emoji;
    html+='<div class="cart-item"><div class="cart-item-img">'+thumb+'</div><div><div class="cart-item-name">'+item.name+'</div><div class="cart-item-price">'+sub+' \u20AC</div><div class="cart-item-qty"><button class="qty-btn" onclick="changeQty(\''+item.id+'\',-1)">\u2212</button><span class="qty-num">'+item.qty+'</span><button class="qty-btn" onclick="changeQty(\''+item.id+'\',1)">+</button></div></div><button class="cart-remove" onclick="changeQty(\''+item.id+'\',-'+item.qty+')">\u00D7</button></div>';
  });
  body.innerHTML=html;
  var pairs=Math.floor(singleQty/2);
  var singleDisc=pairs*30;
  var duoDisc=duoQty*30;
  var discount=singleDisc+duoDisc;
  var finalTotal=total-discount;
  var ts=finalTotal.toFixed(2).replace('.',',')+' \u20AC';
  var ct=document.getElementById('cartTotal'),cb=document.getElementById('cartTotalBtn');
  if(ct)ct.textContent=ts;if(cb)cb.textContent=ts;
  var disc=document.getElementById('cartDiscount');
  if(!disc){
    var subEl=document.querySelector('.cart-subtotal');
    if(subEl){disc=document.createElement('div');disc.id='cartDiscount';disc.style.cssText='font-size:12px;color:#BD106D;font-weight:600;margin-bottom:8px;';subEl.parentNode.insertBefore(disc,subEl);}
  }
  if(disc){
    var lines='';
    if(singleDisc>0){var sPct=Math.round((singleDisc/(pairs*258))*100);var sLabel=pairs===1?'Offre duo &mdash; 2 coffrets pour 228&euro; (&minus;'+sPct+'%)':'Offre duo &times;'+pairs+' &mdash; '+(pairs*2)+' coffrets achet&eacute;s (&minus;'+sPct+'%)';lines+='<div style="display:flex;justify-content:space-between;margin-bottom:4px;"><span>'+sLabel+'</span><span>&minus;'+singleDisc.toFixed(2).replace('.',',')+' \u20AC</span></div>';}
    if(duoDisc>0){var dPct=Math.round((30/260)*100);var dLabel=duoQty===1?'Offre Duo Coffret &mdash; &eacute;conomie de 30&euro; (&minus;'+dPct+'%)':'Offre Duo Coffret &times;'+duoQty+' &mdash; &eacute;conomie de '+duoDisc+'&euro; (&minus;'+dPct+'%)';lines+='<div style="display:flex;justify-content:space-between;margin-bottom:4px;"><span>'+dLabel+'</span><span>&minus;'+duoDisc.toFixed(2).replace('.',',')+' \u20AC</span></div>';}
    if(lines){disc.innerHTML=lines;disc.style.display='block';}else{disc.style.display='none';}
  }
  footer.style.display='block';
}

/* ── SEARCH ── */
function openSearch(){var o=document.getElementById('searchOverlay');if(o)o.classList.add('open');setTimeout(function(){var i=document.getElementById('searchInput');if(i)i.focus();},100);}
function closeSearch(){var o=document.getElementById('searchOverlay');if(o)o.classList.remove('open');}

/* ── HERO SLIDER ── */
var cur=0;var TOTAL=3;
function slideTo(n){
  var track=document.getElementById('heroTrack');
  if(!track)return;
  cur=((n%TOTAL)+TOTAL)%TOTAL;
  track.style.transform='translateX(-'+cur*100+'%)';
  document.querySelectorAll('.hero-dot').forEach(function(d,i){d.classList.toggle('on',i===cur);});
}

/* ── PRODUCT GALLERY — opacity fade ── */
var galCur=0;
function galleryTo(n){
  galCur=n;
  document.querySelectorAll('.gallery-slide').forEach(function(s,i){s.classList.toggle('active',i===n);});
  document.querySelectorAll('.thumb').forEach(function(t,i){t.classList.toggle('active',i===n);});
}
function galleryNav(d){
  var total=document.querySelectorAll('.gallery-slide').length;
  if(!total)return;
  galCur=((galCur+d)%total+total)%total;
  galleryTo(galCur);
}

/* ── PRODUCT ACCORDIONS ── */
function toggleAccordion(btn){
  var item=btn.parentElement;
  var wasOpen=item.classList.contains('open');
  item.classList.toggle('open');
  var icon=btn.querySelector('.accordion-icon');
  if(icon)icon.textContent=wasOpen?'+':'\u2212';
}

/* ── NEWSLETTER ── */
function submitNl(){var el=document.getElementById('nlEmail');if(!el)return;var v=el.value.trim();if(!v||!v.includes('@'))return;var f=document.querySelector('.nl-form');if(f)f.innerHTML='<p style="color:var(--deep);font-weight:700;font-size:14px;padding:12px 0">\u{1F389} Merci ! V\u00E9rifiez votre bo\u00EEte mail.</p>';}

/* ── LANG ── */
function setLang(l,btn){
  document.querySelectorAll('.lang-btn').forEach(function(b){b.classList.remove('active');});
  btn.classList.add('active');
}

/* ══ INIT — runs when DOM is ready ══ */
document.addEventListener('DOMContentLoaded', function(){

  /* Popup */
  setTimeout(function(){var p=document.getElementById('popup');if(p&&!sessionStorage.getItem('rm_pop'))p.style.display='flex';},4000);

  /* Escape key */
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeSearch();closeMenu();closeCart();}});

  /* Hero auto-slide */
  setInterval(function(){slideTo(cur+1);},5500);

  /* Coming Soon — auto-scroll + manual */
  var comGrid=document.querySelector('.coming-grid');
  if(comGrid){
    var comSpeed=1;
    var comPaused=false;
    var comTimer=null;
    function comAutoScroll(){
      if(comPaused)return;
      comGrid.scrollLeft+=comSpeed;
      if(comGrid.scrollLeft>=comGrid.scrollWidth-comGrid.clientWidth){
        comGrid.scrollLeft=0;
      }
    }
    comTimer=setInterval(comAutoScroll,30);
    comGrid.addEventListener('touchstart',function(){comPaused=true;});
    comGrid.addEventListener('touchend',function(){setTimeout(function(){comPaused=false;},2000);});
    comGrid.addEventListener('mouseenter',function(){comPaused=true;});
    comGrid.addEventListener('mouseleave',function(){setTimeout(function(){comPaused=false;},1000);});
  }

  /* Scroll Reveal — fade-in */
  var revEls=document.querySelectorAll('.rev');
  if(revEls.length){
    var ro=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('in');
          ro.unobserve(e.target);
        }
      });
    },{threshold:0.1,rootMargin:'0px 0px -60px 0px'});
    revEls.forEach(function(el){ro.observe(el);});
  }

});

/* ── BACK-IN-STOCK (Klaviyo hook prêt) ── */
function openBis(productName){
  var m=document.getElementById('bisModal'),o=document.getElementById('bisOverlay');
  var p=document.getElementById('bisProduct');
  if(p&&productName)p.textContent=productName;
  if(m){m.classList.remove('sent');m.classList.add('open');}
  if(o)o.classList.add('open');
  var inp=document.getElementById('bisEmail');
  if(inp){setTimeout(function(){inp.focus();},150);}
  document.body.style.overflow='hidden';
}
function closeBis(){
  var m=document.getElementById('bisModal'),o=document.getElementById('bisOverlay');
  if(m)m.classList.remove('open');
  if(o)o.classList.remove('open');
  document.body.style.overflow='';
}
function submitBis(e){
  e.preventDefault();
  var email=document.getElementById('bisEmail').value;
  var product=document.getElementById('bisProduct').textContent;
  try{
    window._learnq=window._learnq||[];
    window._learnq.push(['identify',{'$email':email}]);
    window._learnq.push(['track','Back In Stock Subscription',{ProductName:product,Email:email}]);
  }catch(err){console.warn('[BIS] Klaviyo push failed',err);}
  var m=document.getElementById('bisModal');
  if(m)m.classList.add('sent');
  setTimeout(closeBis,2400);
  return false;
}

/* ── SHOPIFY AJAX CART (hijack /cart/add forms + drawer sync) ── */
(function(){
  if(typeof window==='undefined')return;
  function isShopify(){
    try{
      var h=window.location.hostname||'';
      if(h.indexOf('myshopify.com')>-1)return true;
      if(h.indexOf('rosemuse.')>-1)return true;
      if(window.Shopify&&window.Shopify.shop)return true;
    }catch(e){}
    return false;
  }
  function money(cents){
    var v=(cents/100).toFixed(2).replace('.',',');
    return v+' \u20AC';
  }
  function getImageUrl(item){
    var candidates=[
      item.featured_image,
      item.image,
      item.variant_featured_image,
      item.product&&item.product.featured_image,
      item.product&&item.product.image
    ];
    var img='';
    for(var i=0;i<candidates.length;i++){
      var c=candidates[i];
      if(!c)continue;
      if(typeof c==='object')img=c.url||c.src||'';
      else img=c;
      if(img)break;
    }
    if(!img)return '';
    if(img.indexOf('//')===0)img='https:'+img;
    if(img.indexOf('/')===0)img=window.location.origin+img;
    if(img.indexOf('?')===-1&&img.indexOf('cdn.shopify.com')>-1)img+='?width=160';
    return img;
  }
  function renderShopifyCart(cart){
    var body=document.getElementById('cartBody');
    var footer=document.getElementById('cartFooter');
    var badge=document.getElementById('cartCountBadge');
    if(!body||!footer)return;
    var oldDisc=document.getElementById('cartDiscount');
    if(!cart||!cart.items||!cart.items.length){
      body.innerHTML='<div class="cart-empty"><svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>Votre panier est vide</div>';
      footer.style.display='none';
      if(badge)badge.style.display='none';
      if(oldDisc)oldDisc.style.display='none';
      return;
    }
    var html='';
    var singleQty=0,duoQty=0;
    cart.items.forEach(function(item){
      var img=getImageUrl(item);
      var name=item.product_title||item.title||'';
      var nameEsc=name.replace(/"/g,'&quot;');
      var thumb=img
        ?'<img src="'+img+'" alt="'+nameEsc+'" loading="lazy" width="72" height="72" onerror="this.parentNode.innerHTML=\'\\u{1F381}\';">'
        :'\u{1F381}';
      var handle=(item.handle||'').toLowerCase();
      if(handle.indexOf('duo')>-1)duoQty+=item.quantity;
      else if(handle.indexOf('kit-shrink-less')>-1||handle.indexOf('coffret')>-1)singleQty+=item.quantity;
      html+='<div class="cart-item" data-key="'+item.key+'">'+
        '<div class="cart-item-img">'+thumb+'</div>'+
        '<div>'+
          '<div class="cart-item-name">'+name+'</div>'+
          '<div class="cart-item-price">'+money(item.final_line_price)+'</div>'+
          '<div class="cart-item-qty">'+
            '<button class="qty-btn" type="button" onclick="shopifyChangeQty(\''+item.key+'\','+(item.quantity-1)+')">\u2212</button>'+
            '<span class="qty-num">'+item.quantity+'</span>'+
            '<button class="qty-btn" type="button" onclick="shopifyChangeQty(\''+item.key+'\','+(item.quantity+1)+')">+</button>'+
          '</div>'+
        '</div>'+
        '<button class="cart-remove" type="button" onclick="shopifyChangeQty(\''+item.key+'\',0)">\u00D7</button>'+
      '</div>';
    });
    body.innerHTML=html;
    var ct=document.getElementById('cartTotal'),cb=document.getElementById('cartTotalBtn');
    if(ct)ct.textContent=money(cart.total_price);
    if(cb)cb.textContent=money(cart.total_price);
    footer.style.display='block';
    if(badge){
      var count=cart.item_count||0;
      if(count>0){badge.textContent=count;badge.style.display='flex';}
      else{badge.style.display='none';}
    }
    var disc=oldDisc;
    if(!disc){
      var subEl=document.querySelector('.cart-subtotal');
      if(subEl){disc=document.createElement('div');disc.id='cartDiscount';disc.style.cssText='font-size:12px;color:#BD106D;font-weight:600;margin-bottom:8px;';subEl.parentNode.insertBefore(disc,subEl);}
    }
    if(disc){
      var lines='';
      var pairs=Math.floor(singleQty/2);
      var singleDisc=pairs*30;
      var duoDisc=duoQty*30;
      if(singleDisc>0){
        var sPct=Math.round((singleDisc/(pairs*258))*100);
        var sLabel=pairs===1?'Offre duo &mdash; 2 coffrets pour 228&euro; (&minus;'+sPct+'%)':'Offre duo &times;'+pairs+' &mdash; '+(pairs*2)+' coffrets achet&eacute;s (&minus;'+sPct+'%)';
        lines+='<div style="display:flex;justify-content:space-between;margin-bottom:4px;"><span>'+sLabel+'</span><span>&minus;'+singleDisc.toFixed(2).replace('.',',')+' \u20AC</span></div>';
      }
      if(duoDisc>0){
        var dPct=Math.round((30/260)*100);
        var dLabel=duoQty===1?'Offre Duo Coffret &mdash; &eacute;conomie de 30&euro; (&minus;'+dPct+'%)':'Offre Duo Coffret &times;'+duoQty+' &mdash; &eacute;conomie de '+duoDisc+'&euro; (&minus;'+dPct+'%)';
        lines+='<div style="display:flex;justify-content:space-between;margin-bottom:4px;"><span>'+dLabel+'</span><span>&minus;'+duoDisc.toFixed(2).replace('.',',')+' \u20AC</span></div>';
      }
      if(cart.total_discount>0){
        lines+='<div style="display:flex;justify-content:space-between;margin-bottom:4px;"><span>R&eacute;duction appliqu&eacute;e</span><span>&minus;'+money(cart.total_discount)+'</span></div>';
      }
      if(lines){disc.innerHTML=lines;disc.style.display='block';}else{disc.style.display='none';}
    }
    var checkoutBtn=document.querySelector('#cartFooter .btn-checkout');
    if(checkoutBtn&&!checkoutBtn.dataset.shopifyBound){
      checkoutBtn.dataset.shopifyBound='1';
      checkoutBtn.addEventListener('click',function(){window.location.href='/checkout';});
    }
  }
  window.shopifyFetchCart=function(){
    return fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){renderShopifyCart(cart);return cart;});
  };
  window.shopifyChangeQty=function(key,qty){
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    }).then(function(r){return r.json();}).then(function(cart){renderShopifyCart(cart);});
  };
  function bindForms(){
    var forms=document.querySelectorAll('form[action="/cart/add"]');
    forms.forEach(function(form){
      if(form.dataset.ajaxBound)return;
      form.dataset.ajaxBound='1';
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var fd=new FormData(form);
        var btn=form.querySelector('button[type="submit"]');
        var oldLabel=btn?btn.textContent:'';
        if(btn){btn.disabled=true;btn.textContent='Ajout...';}
        fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
          .then(function(r){return r.json().then(function(d){return {ok:r.ok,data:d};});})
          .then(function(res){
            if(!res.ok){throw res.data;}
            return window.shopifyFetchCart();
          })
          .then(function(){
            if(typeof openCart==='function')openCart();
          })
          .catch(function(err){
            console.warn('[Cart] add failed',err);
            var msg=(err&&err.description)||(err&&err.message)||'Impossible d\'ajouter au panier';
            alert(msg);
          })
          .then(function(){
            if(btn){btn.disabled=false;btn.textContent=oldLabel;}
          });
      });
    });
  }
  function init(){
    if(!isShopify())return;
    bindForms();
    window.shopifyFetchCart();
    var origOpenCart=window.openCart;
    window.openCart=function(){
      window.shopifyFetchCart().then(function(){
        var d=document.getElementById('cartDrawer'),o=document.getElementById('cartOverlay');
        if(d)d.classList.add('open');if(o)o.classList.add('open');
        document.body.style.overflow='hidden';
      });
    };
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
  else{init();}
})();
